import type {
  User,
  Trilha,
  Curso,
  Modulo,
  Aula,
  ConteudoAula,
  ProgressoResumo,
  Certificado,
  Turma,
  Documento,
  Favorito,
  Anotacao,
  Quiz,
  Questao,
} from '../types';

// Usuários mockados com diferentes níveis de permissão
export const mockUser: User = {
  id: '1',
  name: 'Admin Silva',
  email: 'admin@meusalt.com.br',
  phoneNumber: '+55 11 98765-4321',
  roles: ['admin'],
  avatarUrl: 'https://i.pravatar.cc/150?img=12',
  isActive: true,
  createdAt: '2024-01-10T10:00:00Z',
  lastLoginAt: '2025-12-30T08:30:00Z',
};

export const mockUsers: User[] = [
  {
    id: '1',
    name: 'Admin Silva',
    email: 'admin@meusalt.com.br',
    phoneNumber: '+55 11 98765-4321',
    roles: ['admin'],
    avatarUrl: 'https://i.pravatar.cc/150?img=12',
    isActive: true,
    createdAt: '2024-01-10T10:00:00Z',
    lastLoginAt: '2025-12-30T08:30:00Z',
  },
  {
    id: '2',
    name: 'Maria Santos',
    email: 'maria.santos@meusalt.com.br',
    phoneNumber: '+55 11 98765-1111',
    roles: ['instrutor'],
    avatarUrl: 'https://i.pravatar.cc/150?img=5',
    isActive: true,
    createdAt: '2024-02-15T10:00:00Z',
    lastLoginAt: '2025-12-29T14:20:00Z',
  },
  {
    id: '3',
    name: 'Carlos Oliveira',
    email: 'carlos.oliveira@meusalt.com.br',
    phoneNumber: '+55 11 98765-2222',
    roles: ['instrutor'],
    avatarUrl: 'https://i.pravatar.cc/150?img=8',
    isActive: true,
    createdAt: '2024-03-20T10:00:00Z',
    lastLoginAt: '2025-12-28T16:45:00Z',
  },
  {
    id: '4',
    name: 'Ana Costa',
    email: 'ana.costa@meusalt.com.br',
    phoneNumber: '+55 11 98765-3333',
    roles: ['aluno'],
    avatarUrl: 'https://i.pravatar.cc/150?img=1',
    isActive: true,
    createdAt: '2024-04-05T10:00:00Z',
    lastLoginAt: '2025-12-30T09:15:00Z',
  },
  {
    id: '5',
    name: 'Pedro Ferreira',
    email: 'pedro.ferreira@meusalt.com.br',
    phoneNumber: '+55 11 98765-4444',
    roles: ['aluno'],
    avatarUrl: 'https://i.pravatar.cc/150?img=3',
    isActive: true,
    createdAt: '2024-05-12T10:00:00Z',
    lastLoginAt: '2025-12-29T11:30:00Z',
  },
  {
    id: '6',
    name: 'Julia Martins',
    email: 'julia.martins@meusalt.com.br',
    phoneNumber: '+55 11 98765-5555',
    roles: ['aluno'],
    avatarUrl: 'https://i.pravatar.cc/150?img=9',
    isActive: false,
    createdAt: '2024-06-20T10:00:00Z',
    lastLoginAt: '2025-11-15T10:00:00Z',
  },
];

// Cursos mockados
export const mockCursos: Curso[] = [
  {
    id: '1',
    titulo: 'Fundamentos do Módulo Financeiro',
    slug: 'fundamentos-modulo-financeiro',
    descricao: 'Aprenda os conceitos básicos do módulo financeiro do ERP, incluindo contas a pagar, contas a receber e gestão de caixa.',
    categoria: 'Financeiro',
    ativo: true,
    capaUrl: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800',
    cargaHorariaMin: 180,
    modulos: [],
    progresso: {
      userId: '1',
      cursoId: '1',
      percentual: 45,
      aulasConcluidas: 9,
      totalAulas: 20,
    },
  },
  {
    id: '2',
    titulo: 'Gestão Fiscal no ERP Salt',
    slug: 'gestao-fiscal-erp-salt',
    descricao: 'Domine os processos fiscais, emissão de notas fiscais, apuração de impostos e obrigações acessórias.',
    categoria: 'Fiscal',
    ativo: true,
    capaUrl: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800',
    cargaHorariaMin: 240,
    modulos: [],
    progresso: {
      userId: '1',
      cursoId: '2',
      percentual: 0,
      aulasConcluidas: 0,
      totalAulas: 15,
    },
  },
  {
    id: '3',
    titulo: 'Compras e Suprimentos',
    slug: 'compras-suprimentos',
    descricao: 'Processos de compras, gestão de fornecedores, cotações e pedidos de compra.',
    categoria: 'Compras',
    ativo: true,
    capaUrl: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800',
    cargaHorariaMin: 120,
    modulos: [],
  },
  {
    id: '4',
    titulo: 'Contabilidade Gerencial',
    slug: 'contabilidade-gerencial',
    descricao: 'Análise de custos, centros de custo, relatórios gerenciais e demonstrações financeiras.',
    categoria: 'Contabilidade',
    ativo: true,
    capaUrl: 'https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=800',
    cargaHorariaMin: 200,
    modulos: [],
  },
  {
    id: '5',
    titulo: 'Gestão de Recursos Humanos',
    slug: 'gestao-rh',
    descricao: 'Folha de pagamento, benefícios, ponto eletrônico e gestão de pessoal.',
    categoria: 'RH',
    ativo: true,
    capaUrl: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800',
    cargaHorariaMin: 150,
    modulos: [],
    progresso: {
      userId: '1',
      cursoId: '5',
      percentual: 100,
      aulasConcluidas: 12,
      totalAulas: 12,
    },
  },
  {
    id: '6',
    titulo: 'Vendas e Faturamento',
    slug: 'vendas-faturamento',
    descricao: 'Gestão de vendas, pedidos, faturamento e relacionamento com clientes.',
    categoria: 'Vendas',
    ativo: true,
    capaUrl: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800',
    cargaHorariaMin: 160,
    modulos: [],
  },
];

// Módulos e Aulas
export const mockModulos: Modulo[] = [
  {
    id: 'm1',
    cursoId: '1',
    titulo: 'Introdução ao Módulo Financeiro',
    ordem: 1,
    aulas: [],
  },
  {
    id: 'm2',
    cursoId: '1',
    titulo: 'Contas a Pagar',
    ordem: 2,
    aulas: [],
  },
  {
    id: 'm3',
    cursoId: '1',
    titulo: 'Contas a Receber',
    ordem: 3,
    aulas: [],
  },
];

export const mockAulas: Aula[] = [
  {
    id: 'a1',
    moduloId: 'm1',
    titulo: 'Visão Geral do Módulo Financeiro',
    ordem: 1,
    tipo: 'video',
    duracaoSeg: 720,
    progresso: {
      id: 'p1',
      userId: '1',
      aulaId: 'a1',
      status: 'concluida',
      ultimaPosicaoSeg: 720,
      updatedAt: '2025-12-28T10:00:00Z',
    },
  },
  {
    id: 'a2',
    moduloId: 'm1',
    titulo: 'Estrutura Organizacional',
    ordem: 2,
    tipo: 'video',
    duracaoSeg: 900,
    progresso: {
      id: 'p2',
      userId: '1',
      aulaId: 'a2',
      status: 'em-andamento',
      ultimaPosicaoSeg: 450,
      updatedAt: '2025-12-29T09:30:00Z',
    },
  },
  {
    id: 'a3',
    moduloId: 'm1',
    titulo: 'Plano de Contas',
    ordem: 3,
    tipo: 'video',
    duracaoSeg: 1080,
  },
  {
    id: 'a4',
    moduloId: 'm2',
    titulo: 'Cadastro de Fornecedores',
    ordem: 1,
    tipo: 'video',
    duracaoSeg: 840,
  },
  {
    id: 'a5',
    moduloId: 'm2',
    titulo: 'Lançamento de Contas a Pagar',
    ordem: 2,
    tipo: 'video',
    duracaoSeg: 960,
  },
];

// Vincular aulas aos módulos
mockModulos[0].aulas = mockAulas.filter(a => a.moduloId === 'm1');
mockModulos[1].aulas = mockAulas.filter(a => a.moduloId === 'm2');
mockModulos[2].aulas = mockAulas.filter(a => a.moduloId === 'm3');

// Vincular módulos aos cursos
mockCursos[0].modulos = mockModulos;

// Conteúdo de aula
export const mockConteudoAula: Record<string, ConteudoAula> = {
  a1: {
    aulaId: 'a1',
    html: `
      <h2>Bem-vindo ao Módulo Financeiro</h2>
      <p>Nesta aula, você terá uma visão geral completa do módulo financeiro e entenderá como ele se integra com os demais módulos do sistema.</p>
      
      <h3>Objetivos de Aprendizado</h3>
      <ul>
        <li>Compreender a estrutura do módulo financeiro</li>
        <li>Conhecer os principais processos</li>
        <li>Identificar integrações com outros módulos</li>
      </ul>

      <h3>Principais Componentes</h3>
      <p>O módulo financeiro é composto por:</p>
      <ul>
        <li><strong>Contas a Pagar:</strong> Gestão de fornecedores e pagamentos</li>
        <li><strong>Contas a Receber:</strong> Gestão de clientes e recebimentos</li>
        <li><strong>Tesouraria:</strong> Controle de caixa e bancos</li>
        <li><strong>Contabilidade:</strong> Lançamentos contábeis e relatórios</li>
      </ul>
    `,
    resumo: 'Introdução ao módulo financeiro do ERP',
    anexos: [
      {
        id: 'anx1',
        titulo: 'Manual do Módulo Financeiro.pdf',
        url: 'https://example.com/manual.pdf',
        tipo: 'application/pdf',
        tamanho: 2048000,
      },
      {
        id: 'anx2',
        titulo: 'Exercícios Práticos.pdf',
        url: 'https://example.com/exercicios.pdf',
        tipo: 'application/pdf',
        tamanho: 1024000,
      },
    ],
  },
  a2: {
    aulaId: 'a2',
    html: `
      <h2>Estrutura Organizacional</h2>
      <p>Aprenda como configurar a estrutura organizacional do sistema para refletir a organização da sua empresa.</p>
      
      <h3>Conceitos Fundamentais</h3>
      <p>A estrutura organizacional define como sua empresa está organizada no sistema:</p>
      <ul>
        <li>Empresa</li>
        <li>Filiais</li>
        <li>Centros de Custo</li>
        <li>Departamentos</li>
      </ul>
    `,
    resumo: 'Configuração da estrutura organizacional',
  },
};

// Trilhas
export const mockTrilhas: Trilha[] = [
  {
    id: 't1',
    nome: 'Certificação Financeiro Completo',
    descricao: 'Trilha completa para se tornar especialista no módulo financeiro do ERP',
    ordem: 1,
    ativo: true,
    dataCriacao: '2024-01-15T10:00:00Z',
    capaUrl: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800',
    cursos: [mockCursos[0], mockCursos[3]],
    totalCursos: 2,
    duracaoTotalMinutos: 480,
    progresso: 23,
  },
  {
    id: 't2',
    nome: 'MBA em Gestão Fiscal',
    descricao: 'Formação completa em gestão fiscal e tributária no ERP',
    ordem: 2,
    ativo: true,
    dataCriacao: '2024-01-20T10:00:00Z',
    capaUrl: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800',
    cursos: [mockCursos[1]],
    totalCursos: 1,
    duracaoTotalMinutos: 240,
    progresso: 0,
  },
  {
    id: 't3',
    nome: 'Fundamentos do ERP Salt',
    descricao: 'Aprenda todos os módulos básicos do sistema ERP Salt',
    ordem: 3,
    ativo: true,
    dataCriacao: '2024-01-10T10:00:00Z',
    capaUrl: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800',
    cursos: [mockCursos[0], mockCursos[2], mockCursos[4]],
    totalCursos: 3,
    duracaoTotalMinutos: 720,
    progresso: 48,
  },
];

// Progresso resumo
export const mockProgressoResumo: ProgressoResumo = {
  cursosInscritos: 3,
  cursosConcluidos: 1,
  aulasAssistidas: 47,
  tempoTotalEstudo: 125.5,
  ultimosCursos: [
    {
      cursoId: '1',
      titulo: 'Fundamentos do Módulo Financeiro',
      thumbnail: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400',
      percentualConcluido: 45.67,
      aulasConcluidas: 10,
      totalAulas: 22,
      ultimoAcesso: new Date().toISOString(),
    },
  ],
  // Campos opcionais para compatibilidade
  nivel: 5,
  percentualGeral: 34,
  cursosEmAndamento: 2,
  ultimaAula: {
    aulaId: 'a2',
    titulo: 'Estrutura Organizacional',
    cursoTitulo: 'Fundamentos do Módulo Financeiro',
    thumbnailUrl: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400',
  },
};

// Certificados
export const mockCertificados: Certificado[] = [
  {
    id: 'cert1',
    userId: '1',
    cursoId: '5',
    codigoValidacao: 'SALT-2025-RH-001234',
    emitidoEm: '2025-12-15T10:00:00Z',
    pdfUrl: 'https://example.com/certificado.pdf',
    hash: 'abc123def456',
  },
];

// Turmas
export const mockTurmas: Turma[] = [
  {
    id: 'turma1',
    titulo: 'Turma Financeiro - Janeiro 2025',
    descricao: 'Turma de treinamento intensivo em módulo financeiro',
    dataInicio: '2025-01-10T00:00:00Z',
    dataFim: '2025-03-10T00:00:00Z',
    ativa: true,
    conteudos: [
      { turmaId: 'turma1', cursoId: '1', tipo: 'curso' },
      { turmaId: 'turma1', trilhaId: 't1', tipo: 'trilha' },
    ],
    alunos: [
      {
        turmaId: 'turma1',
        userId: '1',
        status: 'ativo',
        inscritoEm: '2025-01-05T00:00:00Z',
      },
    ],
  },
  {
    id: 'turma2',
    titulo: 'Turma Fiscal - Fevereiro 2025',
    descricao: 'Capacitação em gestão fiscal e tributária',
    dataInicio: '2025-02-01T00:00:00Z',
    dataFim: '2025-04-01T00:00:00Z',
    ativa: true,
    conteudos: [
      { turmaId: 'turma2', cursoId: '2', tipo: 'curso' },
    ],
    alunos: [
      {
        turmaId: 'turma2',
        userId: '1',
        status: 'ativo',
        inscritoEm: '2025-01-20T00:00:00Z',
      },
    ],
  },
];

// Documentos
export const mockDocumentos: Documento[] = [
  {
    id: 'doc1',
    titulo: 'Manual de Configuração - CT-e',
    descricao: 'Guia completo de configuração de CT-e no módulo fiscal',
    categoria: 'Fiscal',
    tags: ['CT-e', 'Transporte', 'NFe'],
    url: 'https://example.com/manual-cte.pdf',
    tipo: 'application/pdf',
    tamanho: 3145728,
    createdAt: '2025-12-01T00:00:00Z',
    updatedAt: '2025-12-15T00:00:00Z',
  },
  {
    id: 'doc2',
    titulo: 'Procedimento - Adiantamento de Fornecedor',
    descricao: 'Como realizar adiantamento a fornecedores no sistema',
    categoria: 'Financeiro',
    tags: ['Adiantamento', 'Fornecedor', 'Contas a Pagar'],
    url: 'https://example.com/adiantamento.pdf',
    tipo: 'application/pdf',
    tamanho: 1048576,
    createdAt: '2025-11-20T00:00:00Z',
    updatedAt: '2025-12-10T00:00:00Z',
  },
  {
    id: 'doc3',
    titulo: 'Manual do Módulo de Compras',
    descricao: 'Documentação completa do módulo de compras e suprimentos',
    categoria: 'Compras',
    tags: ['Compras', 'Pedidos', 'Cotação'],
    url: 'https://example.com/manual-compras.pdf',
    tipo: 'application/pdf',
    tamanho: 5242880,
    createdAt: '2025-10-15T00:00:00Z',
    updatedAt: '2025-12-01T00:00:00Z',
  },
  {
    id: 'doc4',
    titulo: 'Guia de Lançamentos Contábeis',
    descricao: 'Principais lançamentos contábeis e sua configuração',
    categoria: 'Contabilidade',
    tags: ['Contabilidade', 'Lançamentos', 'DRE'],
    url: 'https://example.com/lancamentos.pdf',
    tipo: 'application/pdf',
    tamanho: 2097152,
    createdAt: '2025-11-01T00:00:00Z',
    updatedAt: '2025-11-25T00:00:00Z',
  },
  {
    id: 'doc5',
    titulo: 'Folha de Pagamento - Configuração',
    descricao: 'Como configurar e processar a folha de pagamento',
    categoria: 'RH',
    tags: ['Folha', 'Salário', 'Benefícios'],
    url: 'https://example.com/folha.pdf',
    tipo: 'application/pdf',
    tamanho: 4194304,
    createdAt: '2025-09-10T00:00:00Z',
    updatedAt: '2025-12-05T00:00:00Z',
  },
];

// Favoritos
export const mockFavoritos: Favorito[] = [
  {
    userId: '1',
    tipo: 'curso',
    refId: '1',
    createdAt: '2025-12-20T00:00:00Z',
  },
  {
    userId: '1',
    tipo: 'curso',
    refId: '3',
    createdAt: '2025-12-22T00:00:00Z',
  },
  {
    userId: '1',
    tipo: 'documento',
    refId: 'doc1',
    createdAt: '2025-12-23T00:00:00Z',
  },
];

// Anotações
export const mockAnotacoes: Anotacao[] = [
  {
    id: 'nota1',
    userId: '1',
    aulaId: 'a1',
    texto: 'Importante: o módulo financeiro integra com todos os outros módulos',
    timestampSeg: 360,
    createdAt: '2025-12-28T10:30:00Z',
  },
  {
    id: 'nota2',
    userId: '1',
    aulaId: 'a1',
    texto: 'Revisar a estrutura organizacional antes de prosseguir',
    timestampSeg: 600,
    createdAt: '2025-12-28T10:35:00Z',
  },
  {
    id: 'nota3',
    userId: '1',
    aulaId: 'a2',
    texto: 'Centro de custo é fundamental para análise gerencial',
    timestampSeg: 420,
    createdAt: '2025-12-29T09:45:00Z',
  },
];

// Quizzes
export const mockQuizzes: Quiz[] = [
  {
    id: 'quiz1',
    cursoId: '1',
    titulo: 'Avaliação - Módulo Financeiro',
    notaMinima: 70,
    ativo: true,
    questoes: [],
  },
];

export const mockQuestoes: Questao[] = [
  {
    id: 'q1',
    quizId: 'quiz1',
    tipo: 'multipla-escolha',
    enunciado: 'Qual é o principal objetivo do módulo financeiro no ERP?',
    opcoes: [
      { id: 'o1', texto: 'Gerenciar vendas', correta: false },
      { id: 'o2', texto: 'Controlar fluxo de caixa e contas', correta: true },
      { id: 'o3', texto: 'Administrar estoque', correta: false },
      { id: 'o4', texto: 'Gerenciar recursos humanos', correta: false },
    ],
    respostaCorreta: 'o2',
  },
  {
    id: 'q2',
    quizId: 'quiz1',
    tipo: 'verdadeiro-falso',
    enunciado: 'O módulo financeiro não se integra com o módulo de compras.',
    opcoes: [
      { id: 'o1', texto: 'Verdadeiro', correta: false },
      { id: 'o2', texto: 'Falso', correta: true },
    ],
    respostaCorreta: 'o2',
  },
];

mockQuizzes[0].questoes = mockQuestoes;
